/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FullfillmentShipping } from './FullfillmentShipping';
import {
    FullfillmentShippingFromJSON,
    FullfillmentShippingFromJSONTyped,
    FullfillmentShippingToJSON,
} from './FullfillmentShipping';

/**
 * 
 * @export
 * @interface PostCheckoutFullfillmentShipping201ResponseAllOfData
 */
export interface PostCheckoutFullfillmentShipping201ResponseAllOfData {
    /**
     * 
     * @type {FullfillmentShipping}
     * @memberof PostCheckoutFullfillmentShipping201ResponseAllOfData
     */
    fullfillmentShipping: FullfillmentShipping;
}

/**
 * Check if a given object implements the PostCheckoutFullfillmentShipping201ResponseAllOfData interface.
 */
export function instanceOfPostCheckoutFullfillmentShipping201ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fullfillmentShipping" in value;

    return isInstance;
}

export function PostCheckoutFullfillmentShipping201ResponseAllOfDataFromJSON(json: any): PostCheckoutFullfillmentShipping201ResponseAllOfData {
    return PostCheckoutFullfillmentShipping201ResponseAllOfDataFromJSONTyped(json, false);
}

export function PostCheckoutFullfillmentShipping201ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostCheckoutFullfillmentShipping201ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fullfillmentShipping': FullfillmentShippingFromJSON(json['fullfillment_shipping']),
    };
}

export function PostCheckoutFullfillmentShipping201ResponseAllOfDataToJSON(value?: PostCheckoutFullfillmentShipping201ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fullfillment_shipping': FullfillmentShippingToJSON(value.fullfillmentShipping),
    };
}

